import { render, staticRenderFns } from "./bottomBlock.vue?vue&type=template&id=3fe1a74d&"
import script from "./bottomBlock.vue?vue&type=script&lang=js&"
export * from "./bottomBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports